import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { useSetTitle } from '@/stores/title-context';

import { PipelineBoardPage } from '@/pages/crm/pipeline/PipelineBoardPage';
import { boardSearchSchema } from '@/pages/crm/pipeline/boardSearch';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// /crm/deals is the Deals nav surface: the tenant's default pipeline board, fronted by the
// addon gate so an addon-off tenant lands on the teaser and a chain tenant on the banner.
function DealsBoardRoute() {
	const { t } = useLingui();
	useSetTitle(t`Deals`);
	return <PipelineBoardPage />;
}

export const Route = createFileRoute('/_authenticated/_app/crm/deals/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['deals.read.own', 'deals.read.all'], redirectTo: '/dashboard' }),
	component: DealsBoardRoute,
	validateSearch: boardSearchSchema,
});
